'use client';

import { ChangeEvent, FormEvent, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Drawer } from '@wishket/design-system';

import { SearchBox } from '@/features/Search';
import { PATH } from '@/shared/constants';
import { useProfile, useRecentKeywords } from '@/shared/hooks';

interface SearchDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const SearchDrawer = ({ isOpen, onClose }: SearchDrawerProps) => {
  const router = useRouter();
  const { profile } = useProfile();
  const [query, setQuery] = useState('');
  const { list, add, remove, removeAll } = useRecentKeywords({
    username: profile?.name,
  });

  const handleQueryChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmedQuery = query.trim().replace(/\s+/g, ' ');
    if (trimmedQuery.length === 0) {
      return;
    }

    add(query);
    router.push(`${PATH.LIST_SEARCH}?q=${query}`);
    setQuery('');
    onClose();
  };

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      direction="top"
      className="z-30 h-full w-full desktop:h-fit"
    >
      <SearchBox
        isOpen={isOpen}
        onClose={onClose}
        query={query}
        onQueryChange={handleQueryChange}
        onSubmit={onSubmit}
        recentSearchList={list}
        onClickDeleteRecentSearchItemButton={remove}
        onClickDeleteAllRecentSearchItemsButton={removeAll}
      />
    </Drawer>
  );
};

export default SearchDrawer;
